import { render } from "./Governance.vue?vue&type=template&id=6cae9bea"
import script from "./Governance.vue?vue&type=script&setup=true&lang=js"
export * from "./Governance.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/Governance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cae9bea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cae9bea', __exports__)) {
    api.reload('6cae9bea', __exports__)
  }
  
  module.hot.accept("./Governance.vue?vue&type=template&id=6cae9bea", () => {
    api.rerender('6cae9bea', render)
  })

}


export default __exports__